import * as yup from "yup"
import { Persona } from "../../types"

export function initialValuesPersona(persona?: Persona | undefined) {
  if (persona) {
    return persona
  }
  return {
    nome: "",
  }
}

export function validationSchemaPersona() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
  })
}
